import * as SendBird from "sendbird";

import { httpAuth } from "@/api/httpAuth";

// Wrapper method to help promisify all of SendBird's callback methods
const promisify = (func, ...args) => {
  return new Promise((resolve, reject) => {
    //Generic Handler
    return func(
      ...args.concat((response, error) => {
        if (error) {
          reject(error);
        }
        resolve(response);
      }),
    );
  });
};

const DEFAULT_CHANNEL_PAGE_SIZE_LIMIT = 30;

export const messagingRequests = {
  connect_to_sendbird: (client, userId, accessToken) => {
    return promisify(client.connect.bind(client), userId, accessToken);
  },

  create_client: () => {
    return new SendBird({ appId: process.env.REACT_APP_SENDBIRD_APPLICATION_ID });
  },

  fetch_contacts: ({ context }) => {
    return httpAuth.post("/v1/messaging/contacts", { context }).json();
  },

  fetch_user: ({ context }) => {
    return httpAuth.post("/v1/messaging/user", { context }).json();
  },

  get_messages: (query) => {
    return promisify(query.load.bind(query));
  },

  get_next_channel_page: async (nextChannelPageQuery) => {
    return {
      channels: await nextChannelPageQuery.next(),
      nextChannelPageQuery: nextChannelPageQuery.hasNext ? nextChannelPageQuery : null,
    };
  },

  get_paginated_channels: async (client, pageSizeLimit = DEFAULT_CHANNEL_PAGE_SIZE_LIMIT) => {
    const query = client.GroupChannel.createMyGroupChannelListQuery();

    query.includeEmpty = true;
    query.limit = pageSizeLimit;

    return await messagingRequests.get_next_channel_page(query);
  },

  send_message: (channel, message) => {
    return promisify(channel.sendUserMessage.bind(channel), message);
  },

  upsert_distinct_channel: (client, userIds) => {
    let groupChannelParams = new client.GroupChannelParams();

    groupChannelParams.isDistinct = true;
    groupChannelParams.isPublic = false;
    groupChannelParams.isDiscoverable = false;
    groupChannelParams.isEphemeral = false;
    groupChannelParams.name = userIds.join(" | ");
    groupChannelParams.addUserIds(userIds);

    return promisify(
      client.GroupChannel.createDistinctChannelIfNotExist.bind(client),
      groupChannelParams,
    );
  },
};
